import { TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';

function CommentCell(props) {
  const { data, cell } = props;

  const cellData = data || cell?.value;
  return (
    <div className="wm-200">
      {cellData ? (
        <div className="ellipsis" title={cellData}>
          <TextStyle>{cellData}</TextStyle>
        </div>
      ) : (
        <TextStyle variation="subdued">
          <FormattedMessage id="app.noData.message" />
        </TextStyle>
      )}
    </div>
  );
}

export default CommentCell;
